import {AcVariantsModificationOption} from '../../../../core/consts/offer-modification-code.enum';

export enum AcVariantsCoverage {
  AC_VARIANT = 'AC_VARIANT',

  // SECTION TABLE
  AC_VEHICLE_THEFT_AND_ELEMENTAL = 'AC_VEHICLE_THEFT_AND_ELEMENTAL', // Kradzież i skutki działania sił przyrody
  AC_HAPPENING_ACCIDENT_AND_DAMAGE = 'AC_HAPPENING_ACCIDENT_AND_DAMAGE', // Wypadek i szkody na pojazdu

  // COMMON TABLES
  AC_METHOD_OF_LIQUIDATION_OF_THE_DAMAGE = 'AC_METHOD_OF_LIQUIDATION_OF_THE_DAMAGE', // Sposób likwidacji szkody
  AC_PARTS = 'AC_PARTS', // Części użyte do naprawy
  AC_EXCESS = 'AC_EXCESS', // Udział własny

  // COMPARISON TABLE
  AC_VALUE_OF_VEHICLE = 'AC_VALUE_OF_VEHICLE', // Wycena pojazdu
  AC_HAPPENING = 'AC_HAPPENING', // Wypadek i uszkodzenia
  AC_HAPPENING_ELEMENTAL = 'AC_HAPPENING_ELEMENTAL', // Szkody przez żywioły
  AC_HAPPENING_ANIMAL = 'AC_HAPPENING_ANIMAL', // Szkody przez zwierzęta
  AC_VEHICLE_THEFT = 'AC_VEHICLE_THEFT', // Kradzież pojazdu
  AC_METHOD_VALUE_OF_VEHICLE = 'AC_METHOD_VALUE_OF_VEHICLE', // Sposób ustalenia wyceny pojazdu
  AC_DEPRECATION = 'AC_DEPRECATION', // Amortyzacja części

  AC_PRODUCT_NAME = 'AC_PRODUCT_NAME',
  AC_REPAIR_PLACE = 'AC_REPAIR_PLACE',
  AC_VALUE_OF_DETRIMENT = 'AC_VALUE_OF_DETRIMENT',
}

export interface AcVariantCoveragePricing {
  name: AcVariantCoverage;
  price?: number;
}

export enum BeesafeAcCoverageVariant {
  NONE = 'NONE',
  MINI = 'AC_MINI',
  WORKSHOP = 'AC_WORKSHOP',
  ASO = 'AC_SERVICE'
}

export type AcVariantCoverage = BeesafeAcCoverageVariant | AcVariantsModificationOption;
